import { Component, Input } from '@angular/core';
import { iso31661 } from 'iso-3166';
import { ExternalMember } from '../../../shared/models/member/external-member.model';

@Component({
  selector: 'def-country-input',
  templateUrl: './country-input.component.html',
  styleUrls: ['./country-input.component.scss'],
})
export class CountryInputComponent {
  @Input() member: ExternalMember;

  countries = iso31661;
}
